const ComboboxControlType = "makeswift::controls::combobox";
function Combobox(config) {
  return { type: ComboboxControlType, config };
}
export {
  Combobox,
  ComboboxControlType
};
//# sourceMappingURL=combobox.js.map